import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Settings, User, FileText, LifeBuoy } from 'lucide-react';
import UserSettings from '@/components/UserSettings';
import SupportForm from '@/components/SupportForm';
import TermsOfUse from '@/components/TermsOfUse';
import BackupSettings from '@/components/BackupSettings';
import { Database } from 'lucide-react';

const SettingsManager = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('user');

  const renderContent = () => {
    switch (activeTab) {
      case 'user':
        return <UserSettings />;
      case 'support':
        return <SupportForm />;
      case 'terms':
        return <TermsOfUse />;
      case 'backup':
        return <BackupSettings />;
      default:
        return null;
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-2xl">
            <Settings className="w-6 h-6" />
            Configurações da Conta
          </DialogTitle>
          <DialogDescription>
            Gerencie suas informações pessoais, termos e suporte.
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex-grow mt-4 flex gap-6 overflow-hidden">
          <aside className="w-1/4 flex flex-col gap-2">
            <Button variant={activeTab === 'user' ? 'secondary' : 'ghost'} className="justify-start gap-2" onClick={() => setActiveTab('user')}>
              <User className="w-4 h-4" /> Dados do Usuário
            </Button>
            <Button variant={activeTab === 'terms' ? 'secondary' : 'ghost'} className="justify-start gap-2" onClick={() => setActiveTab('terms')}>
              <FileText className="w-4 h-4" /> Termos de Uso
            </Button>
            <Button variant={activeTab === 'support' ? 'secondary' : 'ghost'} className="justify-start gap-2" onClick={() => setActiveTab('support')}>
              <LifeBuoy className="w-4 h-4" /> Suporte
            </Button>
            <Button variant={activeTab === 'backup' ? 'secondary' : 'ghost'} className="justify-start gap-2 text-blue-400 hover:text-blue-300 hover:bg-blue-900/20" onClick={() => setActiveTab('backup')}>
              <Database className="w-4 h-4" /> Backup de Dados
            </Button>
          </aside>
          <main className="w-3/4 flex-grow overflow-y-auto pr-4">
            {renderContent()}
          </main>
        </div>
        
        <div className="flex justify-end gap-3 pt-4 border-t border-white/10 mt-auto">
          <Button variant="outline" onClick={onClose}>Fechar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsManager;